import GjwForm from './src/GjwForm'

GjwForm.install = function(Vue) {
  Vue.component(GjwForm.name, GjwForm)
}

export default GjwForm
